export const getIdsFromOffers = (offers) => offers.map(({ id }) => id);
export const getProductsWithAnalytics = (offers, analyticsItems) => offers.map((offer) => ({
    ...offer,
    sold: analyticsItems?.[offer.id]?.sold || 0,
}));
